import { useEffect, useState } from 'react';
import styles from '../../styles/modules/modal/Modal.module.scss';

const START_SECONDS = 59;

const ModalTimer = () => {
	const [secondsLeft, setSecondsLeft] = useState(START_SECONDS);

	useEffect(() => {
		if (secondsLeft <= 0) return;

		const interval = setInterval(() => {
			setSecondsLeft((prev) => prev - 1);
		}, 1000);

		return () => clearInterval(interval);
	}, [secondsLeft]);

	const minutes = Math.floor(secondsLeft / 60);
	const seconds = secondsLeft % 60;

	return (
		<div className={styles.timer}>
			<div className={styles.timerBlock}>
				<div className={styles.timerValue}>{String(minutes).padStart(2, '0')}</div>
				<div className={styles.timerLabel}>МИН</div>
			</div>

			<div className={styles.timerBlock}>
				<div className={styles.timerValue}>{String(seconds).padStart(2, '0')}</div>
				<div className={styles.timerLabel}>СЕК</div>
			</div>
		</div>
	);
};

export default ModalTimer;
